export default __webpack_public_path__ + "static/media/ic-sm-harvesting-2.c33e3454.svg";